































import { Vue, Component, Emit, Prop } from 'vue-property-decorator'
import { List } from 'vant'
import { ensureLogin } from '@utils/decorators'
import { isHzwApp, toV } from '@utils/index'

const avatar = require('@assets/images/avatar_advi@3x.png')

@Component({
  components: {
    [List.name]: List,
  },
  filters: {
    avatar(src: string | undefined) {
      return src ? src : avatar
    },
  },
})
export default class CounselorList extends Vue {
  @Prop() readonly result!: any

  get loadingText() {
    return this.result && this.result.pageIndex <= 1 ? '' : '加载中...'
  }

  get finishedText() {
    return ''
  }
  get showEntity() {
    return this.result && this.result.list.length > 0
  }
  get showEmpty() {
    return this.result && this.result.finished && this.result.list.length === 0
  }

  @Emit('onLoad')
  onLoad() {}

  @ensureLogin()
  toIM(workerInfo: any) {
    const imHref = `//a.app.qq.com/o/simple.jsp?pkgname=com.kidswant.ss&cmd=usercard&userid=${workerInfo.uid || ''}`
    if (isHzwApp()) {
      if (workerInfo.userType === 1) {
        window.location.href = `//im.cekid.com/shequ/chat/?targetId=${workerInfo.uid}&cmd=imconversation&scenetype=11&userid=${workerInfo.uid}&refresh=no`
      } else {
        window.location.href = imHref
      }
    } else {
      window.location.href = imHref
    }
  }
  toUser(item: any) {
    toV({ name: 'user', params: { uid: item.uid } })
  }
}
